var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 10,
    stroke: "#608175",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 11.875C13.125 10.8395 13.9645 10 15 10C16.0355 10 16.875 10.8395 16.875 11.875C16.875 12.5624 16.505 13.1635 15.9534 13.4899C15.478 13.7711 15 14.1977 15 14.75V16",
    stroke: "#608175",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19,
    r: 0.5,
    fill: "#608175",
    stroke: "#608175"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqLink);
export default __webpack_public_path__ + "static/media/faq-link.65a8e5d0325f2da38d82ee6f225b26ea.svg";
export { ForwardRef as ReactComponent };